<aside class="loading-debug-panel fixed bottom-4 right-4 z-[1200] w-[min(24rem,calc(100vw-2rem))]">
  <mat-card class="loading-debug-panel__card border" appearance="outlined">
    <div class="flex items-center justify-between gap-3">
      <div>
        <div class="text-sm font-semibold">Loading Debug</div>
        <div class="text-xs opacity-70">
          {{ activeLoaderCount$ | async }} active tokens
        </div>
      </div>

      <div class="flex items-center gap-1">
        <button mat-icon-button type="button" aria-label="Clear all loaders" (click)="clearAll()">
          <mat-icon>cleaning_services</mat-icon>
        </button>
        <button mat-icon-button type="button" aria-label="Toggle loading debug panel" (click)="toggleCollapsed()">
          <mat-icon>{{ (collapsed$ | async) ? 'expand_less' : 'expand_more' }}</mat-icon>
        </button>
      </div>
    </div>

    <ng-container *ngIf="expandedSnapshot$ | async as debugSnapshot">
      <div class="mt-3 space-y-3 text-xs">
        <div class="grid grid-cols-3 gap-2">
          <div class="rounded border px-2 py-1">
            <div class="opacity-70">Fullscreen</div>
            <div class="font-semibold">{{ debugSnapshot.activeFullscreen ? 'on' : 'off' }}</div>
          </div>
          <div class="rounded border px-2 py-1">
            <div class="opacity-70">Top bar</div>
            <div class="font-semibold">{{ debugSnapshot.activeTopBar ? 'on' : 'off' }}</div>
          </div>
          <div class="rounded border px-2 py-1">
            <div class="opacity-70">Sections</div>
            <div class="font-semibold">{{ debugSnapshot.activeSectionCount }}</div>
          </div>
        </div>

        <div class="grid grid-cols-2 gap-3">
          <div>
            <div class="mb-1 font-semibold">By mode</div>
            <div *ngFor="let modeCount of debugSnapshot.countsByMode | keyvalue" class="flex items-center justify-between rounded border px-2 py-1">
              <span>{{ modeCount.key }}</span>
              <span class="font-semibold">{{ modeCount.value }}</span>
            </div>
          </div>

          <div>
            <div class="mb-1 font-semibold">By scope</div>
            <div *ngFor="let scopeCount of debugSnapshot.countsByScopeType | keyvalue" class="flex items-center justify-between rounded border px-2 py-1">
              <span>{{ scopeCount.key }}</span>
              <span class="font-semibold">{{ scopeCount.value }}</span>
            </div>
          </div>
        </div>

        <div class="max-h-80 space-y-2 overflow-auto pr-1">
          <div *ngFor="let loaderDebugEntry of debugSnapshot.entries; trackBy: trackByTokenId" class="rounded border p-2">
            <div class="flex items-start justify-between gap-2">
              <div class="min-w-0">
                <div class="truncate font-semibold">{{ loaderDebugEntry.tokenId }}</div>
                <div class="opacity-70">
                  {{ loaderDebugEntry.mode }} · {{ loaderDebugEntry.scopeType }}:{{ loaderDebugEntry.scopeKey }}
                </div>
              </div>

              <button
                mat-icon-button
                type="button"
                aria-label="Clear scope loader"
                (click)="clearScope(loaderDebugEntry.scopeType, loaderDebugEntry.scopeKey)"
              >
                <mat-icon>close</mat-icon>
              </button>
            </div>

            <div class="mt-2 grid grid-cols-2 gap-x-2 gap-y-1 opacity-80">
              <div>owner: {{ loaderDebugEntry.ownerKey }}</div>
              <div>status: {{ loaderDebugEntry.status }}</div>
              <div>group: {{ loaderDebugEntry.groupId || 'none' }}</div>
              <div>reference: {{ loaderDebugEntry.referenceKey || 'none' }}</div>
              <div>started: {{ loaderDebugEntry.startedAtEpochMs }}</div>
              <div>priority: {{ loaderDebugEntry.resolvedPriority }}</div>
              <div>suppressed: {{ loaderDebugEntry.visuallySuppressed ? 'yes' : 'no' }}</div>
              <div>age: {{ loaderDebugEntry.ageMs }}ms</div>
              <div>visible: {{ loaderDebugEntry.visibleDurationMs }}ms</div>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </mat-card>
</aside>
